<div class="w-100 h-100 d-flex flex-column align-items-start wrapper animated fadeIn">
	<button type="button" data-test-id="btn-back" class="btn btn-back" (click)="openTotalSavingPanel.emit()">Back</button>

	<div class="header d-flex align-items-baseline">
		<h2 class="title mb-0" data-test-id="text-title">SP allocations</h2>
	</div>

	<div class="d-flex w-100 h-100">
		<div class="block block--before mr-3 w-100">
			<div class="block__state" data-test-id="text-block-state">Current state</div>

			<div class="breakdowns w-100">
				<div class="breakdowns__item" data-test-id="text-breakdown-item-1">SP cover Linux workloads</div>
			</div>

			<div class="total-savings mt-auto w-100">
				<div class="total-savings__title" data-test-id="text-total-savings-title">Total saving</div>
				<div class="total-savings__value" data-test-id="text-total-savings-value">
					{{ data.oldSPsSavings | currency : 'USD' : 'symbol' : '1.0-0' }}
				</div>
			</div>
		</div>

		<div class="block block--after w-100">
			<div class="block__state" data-test-id="text-block-state-after">After allocation</div>

			<div class="breakdowns breakdowns--after w-100">
				<div class="breakdowns__item" data-test-id="text-breakdown-item-2">
					RIs will be purchased to replace the SPs
				</div>
				<div class="breakdowns__item" data-test-id="text-breakdown-item-3">
					SPs will be reallocated to cover other workload type
				</div>
			</div>

			<div class="total-savings mt-auto w-100">
				<div class="total-savings__title" data-test-id="text-total-savings-title-after">Total saving</div>
				<div class="total-savings__value d-flex flex-column" data-test-id="text-total-savings-value-after">
					{{
						roundAndSumNumbers(data.oldSPsSavings, data.monthlyShiftingAdditionalSavings)
							| currency : 'USD' : 'symbol' : '1.0-0'
					}}
					<div class="total-savings__extra" data-test-id="text-total-savings-extra">
						Additional savings:
						{{ data.monthlyShiftingAdditionalSavings | currency : 'USD' : 'symbol' : '1.0-0' | emptyValue }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
